<app-vehicle-summary
  [vehicle]="vehicle"
  [allowEdit]="allowEditVehicle$ | async"
  [isActive]="isActive"
  [tabIndexPosition]="tabIndexPosition"
  (vehicleClick)="vehicleClick()"
  (deleteVehicle)="deleteVehicle()"
></app-vehicle-summary>
